import React from "react";
import PlayCircleFilledWhiteOutlinedIcon from "@material-ui/icons/PlayCircleFilledWhiteOutlined";
import { GenericPlayer } from "../../plugins/GenericPlayer";
import { embedLink } from "../../helpers/embed.helper";

export function IframeModule(props) {
  const { url } = props.settings;
  if (!url) return <DefaultVideoFrame />;
  return (
    <div id="v-frame" style={{ width: "100%", height: "100%" }}>
      <GenericPlayer url={url} />
      {/*   <iframe
        src={url}
        frameBorder={"false"}
        style={{
          width: "100%",
          height: "100%",
          margin: 0,
          padding: 0,
          border: 0,
        }}
        allowFullScreen={true}
      /> */}
    </div>
  );
}

const DefaultVideoFrame = () => (
  <div
    style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#222",
      position: "relative",
    }}
  >
    <PlayCircleFilledWhiteOutlinedIcon
      className="centered-text c-w"
      style={{ fontSize: "10vh" }}
    />
  </div>
);

const RatioWrapper = ({
  children,
  height,
  width,
  aspectRatio,
  lockAspectRatio,
  bound,
}) => {
  if (!lockAspectRatio) return children;
  return (
    <div
      style={
        lockAspectRatio ? aspecRatio(width, height, aspectRatio, bound) : {}
      }
    >
      {children}
    </div>
  );
};
const aspecRatio = (w, h, ratio, bound) => {
  const defStyle = { height: "100%", width: "100%" };
  switch (ratio) {
    case "16:9":
      return {
        ...defStyle,
        /* paddingTop: "56.2%",  */ maxHeight:
          bound.clientWidth * (parseInt(w) / 100) * 0.562,
      };
    case "16:10":
      return {
        ...defStyle,
        maxHeight: bound.clientWidth * (parseInt(w) / 100) * 0.625,
      };
    case "4:3":
      return {
        ...defStyle,
        maxHeight: bound.clientWidth * (parseInt(w) / 100) * 0.75,
      };
    default:
      return defStyle;
  }
};
